import React from 'react';
const LOGO_URL = 'https://cdn.magicpatterns.com/patterns/generated-images/eea3d371-fb1c-4cbf-9f61-64776c72582e.jpg';
interface LogoProps {
  /** emblem diameter in px */
  size?: number;
  /** brand text size scale */
  variant?: 'sm' | 'md' | 'lg';
  light?: boolean;
  className?: string;
}
const textScale = {
  sm: {
    brand: 'text-base',
    eyebrow: 'text-[9px]'
  },
  md: {
    brand: 'text-xl',
    eyebrow: 'text-[10px]'
  },
  lg: {
    brand: 'text-2xl',
    eyebrow: 'text-[11px]'
  }
};
export function Logo({
  size = 44,
  variant = 'md',
  light = false,
  className = ''
}: LogoProps) {
  const scale = textScale[variant];
  return <span className={`flex items-center gap-3 ${className}`} data-id="element-243">
      <span className="flex shrink-0 items-center justify-center rounded-full ring-1 ring-gold/40 bg-white shadow-sm overflow-hidden" style={{
      width: size,
      height: size
    }} data-id="element-244">
        <img src={LOGO_URL} alt="Golden Care logo" width={size} height={size} className="h-full w-full object-cover scale-110" data-id="element-245" />
      </span>
      <span className="flex flex-col leading-none" data-id="element-246">
        <span className={`font-display font-bold tracking-[0.12em] ${scale.brand} ${light ? 'text-white' : 'text-ink'}`} data-id="element-247">
          GOLDEN CARE
        </span>
        <span className={`mt-1 font-sans font-semibold uppercase tracking-[0.32em] text-gold-dark ${scale.eyebrow}`} data-id="element-248">
          Premium Agencija
        </span>
      </span>
    </span>;
}